const INSTANCIA_INFORMADORA_DEFAULT = 'RECURSOS HUMANOS'

export default class EvaluacionDesempenio {
  id
  idEvaluado
  idEvaluador
  idPeriodicidad
  periodicidad
  fechaInicio
  fechaConclusion
  fechaAplicacion
  instanciaInformadora

  constructor(idEvaluado) {
    this.id = null
    this.idEvaluado = idEvaluado
    this.idEvaluador = null
    this.idPeriodicidad = null
    this.periodicidad = ''
    this.fechaInicio = null
    this.fechaConclusion = null
    this.fechaAplicacion = null
    // TODO: Mover a disciplina administrativa y operativa. Prop no requierda en respeto y principio
    this.instanciaInformadora = INSTANCIA_INFORMADORA_DEFAULT
  }
}
